import './styles';

import React from 'react';

import { loadPublicationFromAPI } from 'details/models/publication';

import Header from './header';
import Footer from 'shared/components/footer';
import NoDataMessage from './no_data_message';
import LoadingMessage from 'details/components/loading_message';
import DocumentMetadata from 'details/components/document_metadata';
import DocumentTabs from 'details/components/document_tabs';
import { RadarThemeProvider as ThemeProvider } from '@radar-ui/core';

export default class DetailsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasLoaded: false,
            publication: null
        };
    }

    render() {
        return (
            <ThemeProvider theme={{ header: { background_color: '#263238' } }}>
                <div className="DetailsPage">
                    {this.obsoleteBrowserWarning}
                    {this.header}
                    {this.content}
                </div>
            </ThemeProvider>
        );
    }

    get header() {
        if (this.state.hasLoaded && this.state.publication) {
            return <Header publication={this.state.publication} rootURL={this.props.config.rootURL} />;
        } else {
            return <Header />;
        }
    }

    get content() {
        if (this.state.hasLoaded && this.state.publication) {
            return this.pageContent;
        } else if (this.state.hasLoaded) {
            return <NoDataMessage config={this.props.config} />;
        } else {
            return <LoadingMessage />;
        }
    }

    get obsoleteBrowserWarning() {
        if (!window.navigator.userAgent.match(/MSIE/i)) return null;

        return (
            <div className="obsolete-browser-warning">
                Your browser is out of date. It has known security flaws and may not display all features of this and
                other websites.{' '}
                <a href="https://browser-update.org/update.html" target="_blank" rel="noopener noreferrer">
                    Click here to learn how to update your browser
                </a>
            </div>
        );
    }

    // When the component mounts, start loading data from the API. If we
    // successfully load data, then we will get a publication passed back to
    // our callback.
    //
    // We load data in multiple requests, so the callback will additionally be
    // called when more data is available – this will update the publication and
    // trigger a re-render.
    componentWillMount() {
        loadPublicationFromAPI(this.props.config, publication =>
            this.setState({ hasLoaded: true, publication: publication })
        );
    }

    get pageContent() {
        return (
            <div className="DetailsPage-content-wrapper">
                <DocumentMetadata publication={this.state.publication} config={this.props.config} />
                <DocumentTabs
                    publication={this.state.publication}
                    rootURL={this.props.config.rootURL}
                    tab={this.props.config.tab}
                />
                <Footer />
            </div>
        );
    }
}
